module.exports = __webpack_public_path__ + "img/Support-skill-126.7ccce138.png";